import { ensureAll } from '../onEnter';
import { getCurrentRouteMatch, getPreviousLocation, getRouteName, isRouterReady } from '../selectors';
import { routerActionCreators, routerActions } from '../state';
import { ILocation, IRouteMatchResult } from '../types';

const buildErrorActions = (previousLocation, reason, ...actions) =>
  [
    !!previousLocation && routerActionCreators.goBack(),
    routerActionCreators.navigationRejected(reason),
    ...actions
  ].filter((action) => !!action);

let isFirstLoad = true;

export const onEnter =
  (pageTrackingCallback, defaultOnEnter = []) =>
  (store) =>
  (next) =>
  (action) => {
    if (action.type !== routerActions.locationChanged.actionType || !isRouterReady(store.getState())) {
      return next(action);
    }

    const locationChangedAction = action as IAction<any, { location: ILocation }>;
    const nextLocation: ILocation = locationChangedAction.payload.location;
    const nextRoute: IRouteMatchResult = getCurrentRouteMatch(store.getState())(nextLocation);

    if (!(nextRoute && nextRoute.result && nextRoute.result.onEnter)) {
      return next(action);
    }

    const { result } = nextRoute;

    const onError = (reason, ...actions) => {
      return buildErrorActions(getPreviousLocation(store.getState()), reason, ...actions).forEach(next);
    };

    const onSuccess = () => {
      const currentRouteName = getRouteName(store.getState());

      if ((isFirstLoad || currentRouteName !== nextRoute.result.name) && pageTrackingCallback) {
        const pageTrackingPropsSelector = nextRoute.result.pageTrackingPropsSelector;
        const pageTrackingProps = (pageTrackingPropsSelector && pageTrackingPropsSelector(store.getState())) || {};
        const pageName = nextRoute.result.pageTrackingPageName || nextRoute.result.name;
        pageTrackingCallback({ pageName, props: pageTrackingProps });
        isFirstLoad = false;
      }

      next(routerActions.navigationAccepted.create({ name: nextRoute.result.name, params: nextRoute.params }));
      next(action);
    };

    if (result.onEnter) {
      ensureAll([...defaultOnEnter, result.onEnter].filter((oe) => !!oe))(
        store.getState(),
        nextRoute,
        onSuccess,
        onError
      );

      return;
    }
  };
